import useAppStore from "@/context/store";
import { integrationAutomerge, logout, switchOrg } from "@/services";
import { AppLink } from "@gdesign/applink";
import { isNil, omitBy } from "lodash";

// 非框架提供的业务容器模式下，需要手动初始化，并且设置 origin
// 初始化
export const applink = new AppLink();

const env = process.env.NEXT_PUBLIC_DEPLOY_ENV;

const gdPath = `https://gd${env === "prod" ? "" : "-" + env}.huaban.com`;

// eg: huaban.com
applink.popup.setOrigin(gdPath);
export function applinkMerge() {
  return new Promise(async (resolve, reject) => {
    const automergeRet = await integrationAutomerge();

    if (automergeRet.result_type === "SUCCESS") {
      // 判断当前用户是否有自动续费订单
      if (automergeRet.is_subscribe_order === true) {
        // 标识用户处于一体化合并中间态, 非已合并账号
        sessionStorage.setItem("mergeState", "1");
        // 有自动续费订单，不进行合并
        resolve(false);
        return;
      }

      sessionStorage.removeItem("mergeState");
      resolve(true);
      return;
    }

    if (automergeRet.err) {
      automergeRet.result_type = "FAIL";
    }

    const mergeEquityModal = applink.open(`/applink/popup/merge-equity`, {
      mode: "iframe",
      props: {
        ...omitBy(automergeRet, isNil),
        design_token: "huaban",
        // project_env: "p785pr11729", // 开发联调使用
      },
    });
    // 合并成功
    mergeEquityModal.on(
      "success",
      async (data: { orgId: string; taskType: { value: string } }) => {
        const orgId = data.orgId;
        const res = await switchOrg(orgId);
        if (res.err) {
          return;
        }

        // 关闭弹窗
        mergeEquityModal.emit("close", {});

        resolve(orgId);
      }
    );

    // 合并失败
    mergeEquityModal.on("fail", (err) => {
      console.error(err);
      reject(err);
    });

    // 刷新重试
    mergeEquityModal.on("reload", async () => {
      mergeEquityModal.emit("close", {});
      const res = await applinkMerge();
      if (res) {
        resolve(res);
      }
    });

    mergeEquityModal.on("login-out", () => {
      logout();
      useAppStore.setState({
        user: null,
      });
    });
  });
}

export function applinkColdBoot() {
  return new Promise((resolve) => {
    const coldBootModal = applink.open("/applink/popup/cold-bootstrap", {
      mode: "iframe",
      props: {
        mask: true,
        design_token: "huaban",
        // project_env: "p785pr11729", // 开发联调使用
      },
    });

    coldBootModal.on("success", async (data) => {
      if (data) {
        await switchOrg(data);
        // 关闭弹窗
        coldBootModal.emit("close", {});
        resolve(true);
      }
    });

    coldBootModal.on("login-out", () => {
      logout();
      useAppStore.setState({
        user: null,
      });
    });
  });
}

export function openMyCoupon() {
  applink.open(`/applink/popup/coupon`, {
    mode: "iframe",
    props: {
      design_token: "huaban",
    },
  });
}

// 在外部直接使用applink实例时，不要使用单例，可能存在初始化origin设置不生效的问题
export const getAppLinkInstance = (origin = gdPath) => {
  if (origin) {
    applink.popup.setOrigin(origin);
  }
  return applink;
};
